<h2 matDialogTitle>Metoda chwilowo niedostępna</h2>

<p>
  Po stronie operatora płatności wystąpiła chwilowa niedyspozycja, przez co ta metoda płatności jest tymczasowo
  niedostępna. Staramy się jak najszybciej wyjaśnić sytuacje. Prosimy o cierpliwość i przepraszamy za niedogodności.
</p>

<mat-dialog-actions align="start">
  <button color="accent" mat-raised-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
